import React from 'react';
import { Link } from 'react-router-dom';
import './Links.scss';

export type LinkItem = {
  to: string | undefined;
  text: string;
  onClick?: () => void;
};

export type LinksProps = {
  id: string;
  title?: string;
  items: LinkItem[];
  icon?: React.ReactNode;
};

export const Links = ({ id, title, items, icon }: LinksProps): JSX.Element => {
  return (
    <div id={id} className='links-widget'>
      {title && <h3>{title}</h3>}
      <ul>
        {items.map((item, i) => (
          <li key={`${id}-${i}`} className='flex-row links-widget-item'>
            <div className='links-widget-icon'>{icon ?? <i>{icon}</i>}</div>
            <Link to={item.to ? item.to : ''} onClick={item.onClick}>
              {item.text}
            </Link>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default Links;
